import styled from "@emotion/styled";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { HeaderBaseProps } from "@kaltura/mediaspace-shared-media-list";
import { DeleteAll } from "./DeleteAll";
import { IconButton, Tooltip } from "@kaltura/ds-react-components";
import { Refresh24Icon } from "@kaltura/ds-react-icons";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * my-history results header component
 */
export const Header = ({ entryResults, onReload }: HeaderBaseProps) => {
    const sendButtonAnalytics = useButtonAnalytics();
    const reloadList = () => {
        sendButtonAnalytics("Refresh Button", ButtonClickAnalyticsType.LOAD, undefined, "My History");
        onReload();
    };

    return (
        <BulkActionsContainer>
            <Tooltip title={translate("Reload My History")}>
                <IconButton
                    variant={"borderless"}
                    color={"secondary"}
                    aria-label={translate("Reload My History")}
                    onClick={reloadList}
                >
                    <Refresh24Icon />
                </IconButton>
            </Tooltip>
            <DeleteAll onReload={onReload} />
        </BulkActionsContainer>
    );
};

const BulkActionsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
}));
